export default __webpack_public_path__ + "static/media/user.3e0765b9.svg";